export const environment: any = {
  production: false,
  url: {
    DATA_URL: 'https://3.6.19.126:9002/api/',
    GEOPORTAL: '/geoserver/APCRDA/',
    DRONE_IMAGERY: 'https://geoportal.apcrda.org/geoserver/APCRDA/',
    AP_AWARE: 'https://dev.apcrda.vassarlabs.com/api/disaster_management/aware/geoserver/AP_AWARE/',
    GEOPORTAL_CACHE: '/geoserver/gwc/service/',
    ACER_GEOSERVER: '/geoserver/gwc/service',
    SEARCH_URL: 'https://3.6.19.126:9003/search/',
    // SEARCH_URL: 'https://localhost:9003/search/',
    HEXAGON_WMS_URL: 'https://15.207.31.94/erdas-iws/ogc/wms',
    MAPPROXY_URL: 'https://3.7.159.86:8081/wms',
    BACKEND_URL: 'https://dev.apcrda.vassarlabs.com/api/',
    UM_URL: 'https://dev.apcrda.vassarlabs.com/um/',
    AWARE_URL: 'https://dev.apcrda.vassarlabs.com/api/disaster_management/aware/',
    // PLAY_DATA : 'https://localhost:9000/api/',
    API_DDN: 'https://api.zip.pr/external/v1/building?',
    LAYER_FIELDS: '/geoserver/wfs?version=1.0.0&request=DescribeFeatureType&typename=REPLACEWITHTYPE&outputFormat=application/json',
    LAYER_FIELDS_VALUE: "/geoserver/wfs?service=WFS&version=1.0.0&request=GetFeature&typeName=REPLACEWITHTYPE&outputFormat=application/json",
    WORKSPACE: 'DMA:',
    WPS_URL: '/geoserver/wps',
    WFS_URL: '/geoserver/wfs',
    XKT_URL: 'https://dev.apcrda.vassarlabs.com/xkt/',
    AWARE_DISASTER_URL: 'https://dev.apcrda.vassarlabs.com/api/disaster_management/aware/',
    VIDEOS_BASE_URL: 'https://geoportal.apcrda.org/portal-ui/videos/',
    DOCS_BASE_URL: 'https://dev.apcrda.vassarlabs.com/assets/docs/'
  }
};
